module.exports = __webpack_public_path__ + "img/ind-zyly.c2000ad5.png";